import { easeInOut, motion } from 'framer-motion';
import { StackedContent } from 'ui';
import Image from 'next/image';

export interface AnimatedHeroProps {
    content: any;
    img: string;
    mobileImg: string;
    bgGradient: string;
}

export function AnimatedHero({content, img, mobileImg, bgGradient}: AnimatedHeroProps) {
    return(
    <motion.div 
        className="h-full lg:h-[80vh] xl:h-[85vh] w-full flex flex-col-reverse lg:flex-row items-center justify-start lg:justify-center bg-left-bottom lg:bg-left mb-32" 
    >
        <div className='w-full lg:max-w-none lg:w-3/5 h-min lg:h-full px-10 lg:pl-[75px] lg:pr-10 2xl:pl-[8vw] pt-5 lg:py-10'
           style={{
                background: bgGradient ? `url('${bgGradient}')` : 'white',
                backgroundSize: "contain",
                backgroundRepeat: 'no-repeat',
                backgroundPosition: 'left'
            }}
        >
            <StackedContent
                fullalways
                fullheight
                mobileCenterLg
                left
                space
                content={content}
            />
        </div>
        <motion.div 
            className='w-full lg:w-2/5 h-full self-start flex items-start justify-end'
            initial={{opacity: 0, x: 10}}
            animate={{opacity: 1, x: 0}}
            transition={{ delay: 0.4, duration: 0.5, ease: 'easeOut' }}
        >
            <Image
                src={img}
                alt="icon" 
                className={`w-auto h-full aspect-[1650/2304] ${mobileImg ? 'hidden lg:block' : ''}`}
                width={1650} 
                height={2304}
            />
            {mobileImg &&
                <Image
                    src={mobileImg}
                    alt="icon" 
                    className="w-full h-auto block lg:hidden"
                    width={1290} 
                    height={750}
                />
            }
        </motion.div>
    </motion.div>
    )
}